import { IntlTFunc } from 'next-intl';

import { FilterOption, SortOption } from '@/api/backend/contract/ProductList';

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
} as const;

export type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION];

export type SortValue = 'popular' | 'new' | 'discount' | 'price';

export const SORT_CONFIG = {
  popularityDesc: {
    value: 'popular',
    direction: SORT_DIRECTION.DESC,
    labelKey: 'catalogProductListing.sortOptions.popularity'
  },
  newProductsDesc: {
    value: 'new',
    direction: SORT_DIRECTION.DESC,
    labelKey: 'catalogProductListing.sortOptions.news'
  },
  discountDesc: {
    value: 'discount',
    direction: SORT_DIRECTION.DESC,
    labelKey: 'catalogProductListing.sortOptions.discount'
  },
  priceAsc: {
    value: 'price',
    direction: SORT_DIRECTION.ASC,
    labelKey: 'catalogProductListing.sortOptions.priceAsc'
  },
  priceDesc: {
    value: 'price',
    direction: SORT_DIRECTION.DESC,
    labelKey: 'catalogProductListing.sortOptions.priceDesc'
  }
} as const;

export type SortKey = keyof typeof SORT_CONFIG;

export const SORT_OPTIONS = (t: IntlTFunc): FilterOption[] =>
  (Object.keys(SORT_CONFIG) as SortKey[]).map((key) => ({
    value: key,
    label: t(SORT_CONFIG[key].labelKey)
  }));

export const SORT_OPTIONS_MAP: Record<
  SortKey,
  {
    value: SortValue;
    direction: SortDirection;
  }
> = SORT_CONFIG;

export const DEFAULT_SORT_OPTION: SortKey = 'popularityDesc';

export const isSortKey = (value: string): value is SortKey => value in SORT_CONFIG;

export const getSortLabelByKey = (t: IntlTFunc, sortKey: string): string | undefined => {
  if (!isSortKey(sortKey)) return undefined;

  return t(SORT_CONFIG[sortKey].labelKey);
};

/**
 * Конвертирует значение сортировки в формат API SortOption[]
 */
export function convertSortToApiFormat(sortValue: string): SortOption[] {
  if (!sortValue || !isSortKey(sortValue)) {
    return [];
  }

  const sortConfig = SORT_CONFIG[sortValue];

  return [
    {
      field: sortConfig.value,
      direction: sortConfig.direction
    }
  ];
}
